import React from 'react';
import { IntlProvider } from '@mb/lib/i18n/CoordinatedIntlProvider';
import { ThemeContainer } from 'ui-widgets';
import { SchedulerEditor, Scheduling, SchedulingModal } from './components';
import { AppProps } from './types';

export const Scheduler = (props: AppProps) => {
  const getDynamicComponent = (componentType: string) => {
    switch (componentType) {
      case 'editor':
        return <SchedulerEditor />;
      case 'scheduling':
        return <Scheduling />;
      case 'modal':
        return <SchedulingModal />;
      default:
        return null;
    }
  };

  return (
    <IntlProvider>
      <ThemeContainer>{getDynamicComponent(props.type)}</ThemeContainer>
    </IntlProvider>
  );
};
